import styled from 'styled-components';

export default styled.ul`
  display: flex;
  flex-wrap: wrap;
`;
